var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9188 21.0074C16.0197 21.9119 15.2443 22.6456 14.6129 22.243L0.570599 13.2894C0.0107407 12.9324 -0.0161689 11.9248 0.520591 11.4169L12.3178 0.254069C12.8546 -0.253828 13.5842 0.0888456 13.6737 0.890878L15.9188 21.0074Z",
    fill: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotTail);
export default __webpack_public_path__ + "static/media/chatbot-tail.efbb524bc9699992dc14cc5323316b03.svg";
export { ForwardRef as ReactComponent };